<template>
    <main>
        <div class="loading"><span></span><span></span><span></span><span></span><span></span></div>
    </main>
</template>

<script>
    export default {
        name: 'loading',
        data() {
            return {}
        },
        components:{

        },
        computed:{

        },
        methods: {

        },
        mounted() {
            this.query = this.$route.query;
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .loading{
        width: 80px;
        height: 20px;
        margin: 0 auto;
    }
    .loading span{
        display: inline-block;
        width: 8px;
        height: 100%;
        margin: 0 3px;
        background: #cccccc;
        -webkit-animation: load 1s ease infinite;
    }
    @-webkit-keyframes load{
        0%,100%{
            height: 20px;
            background: #cccccc;
        }
        50%{
            height: 35px;
            margin: -7px 3px;
            background: #cccccc;
        }
    }
    .loading span:nth-child(2){
        -webkit-animation-delay:0.2s;
    }
    .loading span:nth-child(3){
        -webkit-animation-delay:0.4s;
    }
    .loading span:nth-child(4){
        -webkit-animation-delay:0.6s;
    }
    .loading span:nth-child(5){
        -webkit-animation-delay:0.8s;
    }
</style>

